export const isHeroku = !!window.localStorage.getItem('ls._heroku_');
